import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import FormGroup from 'react-bootstrap/FormGroup';
import FormControl from 'react-bootstrap/FormControl';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import CustomCheckbox from '../../Common/CustomCheckbox';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import Loader from '../../Common/Loader/Loader';

import messages from '../../../locale/messages';
import validate from './validate';
import { createAdminRole } from '../../../actions/siteadmin/AdminRoles/manageAdminRoles';

import bt from '../../../components/commonStyle.css';
import s from './AdminRolesForm.css';


class AdminRolesForm extends Component {
  constructor(props) {
    super(props);
  }

  renderCheckbox = ({ input, label, meta: { touched, error }, options, className }) => {
    const { formatMessage } = this.props.intl;
    let currentValue = input.value || [];
    return (
      <>
        <Row>
          {
            options && options.length > 0 && options.map((option, index) => {
              return (
                <Col xl={6} lg={6} md={12} sm={12} xs={12} key={index} className={s.checkboxLabelContainer}>
                  <CustomCheckbox
                    {...input}
                    className='commonCustomCheckBox'
                    containerClassName={cx(s.textWidth, 'commonCustomCheckFlex')}
                    label={option.name}
                    value={option.id}
                    name={`${input.name}[${index}]`}
                    checked={currentValue.indexOf(option.id) !== -1}
                    onChange={(event) => {
                      const newValue = [...currentValue] || [];
                      if (event === true) {
                        newValue.push(option.id);
                      } else {
                        newValue.splice(newValue.indexOf(option.id), 1);
                      }
                      return input.onChange(newValue);
                    }}
                  />
                </Col>
              )
            })
          }
        </Row>
        {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
      </>
    );
  }


  handleFormSubmit = async (values) => {
    const { createAdminRole, paginationData, currentPage } = this.props;
    await createAdminRole(
      values.id,
      values.name,
      values.description,
      values.privileges,
      currentPage
    );
    !values?.id && paginationData(1);
  }

  render() {
    const { error, handleSubmit, submitting, id, privileges, loading } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx('maxwidthcenter', 'empty')}>
        <form onSubmit={handleSubmit(this.handleFormSubmit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className={cx('oneColumnGrid', bt.space3)}>
            <Field
              name="name"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.roleName)}
              placeholder={formatMessage(messages.roleName)}
              inputClass={cx(bt.formControlInput)}
            />
            <Field
              name="description"
              component={InputFieldComponent}
              componentClass="textarea"
              label={formatMessage(messages.description)}
              placeholder={formatMessage(messages.description)}
              inputClass={bt.formTextArea}
            />
          </div>
          <FormGroup className={cx(bt.noMargin)}>
            <label className={bt.commonLabelText} ><FormattedMessage {...messages.privileges} /></label>
            <Field
              name="privileges"
              component={this.renderCheckbox}
              options={privileges}
              className={cx(bt.space3)}
            />
          </FormGroup>
          <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
            <Loader
              type='button'
              show={loading}
              className={cx(bt.btnPrimary)}
              bsSize="large"
              buttonType="submit"
              disabled={submitting}
              label={id ? formatMessage(messages.update) : formatMessage(messages.add)}
            />
          </div>
        </form>
      </div>
    )
  }
}
AdminRolesForm = reduxForm({
  form: "AdminRolesForm", // a unique name for this form
  validate,
})(AdminRolesForm);
const selector = formValueSelector('AdminRolesForm');
const mapState = (state) => ({
  id: selector(state, 'id'),
  privileges: state.commonSettings.privileges,
  loading: state.loader.adminRoleLoading
});
const mapDispatch = {
  createAdminRole
};
export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(AdminRolesForm)));